import {
  Box,
  List,
  makeStyles,
  Typography,
  CircularProgress,
  Button,
  IconButton,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from "@material-ui/core";
import { useState, useEffect, useContext, useMemo, useRef } from "react";
import { AuthContext } from "../../../../context";
import { productsServices } from "../../../../services";
import { capitalizeFirstLetterArray } from "../../../../helpers";
import ItemQuantityControl from "./ItemQuantityControl";
import KeyboardArrowDownRoundedIcon from "@material-ui/icons/KeyboardArrowDownRounded";
import UserListItem from "./UserItemList";
export default function AssignToRepresentative({
  assignments,
  addProduct,
  removeProduct,
  updateProductQty,
  labRepresentative,
  onSubmit,
}) {
  const { authState, signOut } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [assignmentsLoading, setAssignmentsLoading] = useState(null);
  const [products, setProducts] = useState([]);
  const classes = useStyles();
  const selectedLabRepresentatives = getSelectedLabRepresentatives(
    Object.keys(assignments),
    labRepresentative
  );

  async function getProducts() {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const labId =
        user.role._id === "5fdb9e3db3bfce86908e440f"
          ? "ALL"
          : user.laboratory["_id"];
      const { status, response } = await productsServices.getProducts({
        laboratoryId: labId,
        page: 1,
        limit: 9999999,
        token: authState.token,
      });
      if (status === 200) {
        setProducts(response.products);
        // setLimit(response.limit);
        // setCount(response.total);
        // setPage(response.page);
      } else if (status === 401) {
        signOut();
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    getProducts();
  }, []);
  const handleSubmit = async ({ labRepreId }) => {
    try {
      setAssignmentsLoading(labRepreId);
      await onSubmit({ labRepreId });
    } catch (error) {
    } finally {
      setAssignmentsLoading(null);
    }
  };

  return (
    <Box>
      <Box className={classes.content_list_repre}>
        <List dense className={classes.list_product}>
          {selectedLabRepresentatives?.map((r) => {
            const isDisabled = r.status !== "active";
            const productsPerRepre = getProductsPerRepre(
              assignments[r._id],
              products
            );
            return (
              <UserListItem
                checked={true}
                key={r._id}
                disabled={isDisabled}
                name={capitalizeFirstLetterArray(
                  `${r.firstName} ${r.lastName}`
                )}
                rut={r.rut}
                zones={r.zones}
                contentListItemIcon={
                  <IconButton className="arrow-rotate" style={{ padding: 4 }}>
                    <KeyboardArrowDownRoundedIcon />
                  </IconButton>
                }
                loading={assignmentsLoading === r._id}
              >
                <form
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 8,
                    marginTop: 12,
                  }}
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit({ labRepreId: r._id });
                  }}
                >
                  {productsPerRepre?.map((p) => (
                    <ItemQuantityControl
                      label={p.label}
                      key={p._id}
                      quantity={p.qty}
                      onChange={(qty) => {
                        updateProductQty(r._id, p._id, qty);
                      }}
                      onDelete={() => {
                        removeProduct(r._id, p._id);
                      }}
                    />
                  ))}
                  <SelectProducts
                    products={products}
                    onSelect={(value) => {
                      addProduct(r._id, value);
                    }}
                    loading={loading}
                  />
                  <Box
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      padding: 12,
                    }}
                  >
                    <Button
                      size="small"
                      style={{ textTransform: "none", width: 100 }}
                      color="primary"
                      variant="contained"
                      type="submit"
                    >
                      Asignar
                    </Button>
                  </Box>
                </form>
              </UserListItem>
            );
          })}
        </List>
      </Box>
    </Box>
  );
}
const useStyles = makeStyles((theme) => ({
  content_list_repre: {
    height: "56vh",
    overflowY: "auto",
  },
  list_product: {
    padding: theme.spacing(0.5),
    marginTop: theme.spacing(1.5),
    "& li": {
      boxShadow: theme.shadows[1],
      marginTop: theme.spacing(1),
      borderRadius: theme.spacing(2),
      "& .arrow-rotate": {
        transitionProperty: "transform",
        transitionDuration: "0.3s",
        transitionTimingFunction: theme.transitions.easing.easeOut,
      },
      '&[data-id="open-expand"]': {
        "& .arrow-rotate": {
          transform: "rotate(-180deg)",
        },
      },
    },
  },
}));

const getSelectedLabRepresentatives = (assignmentData, sourceData) => {
  const filledData = assignmentData.map((_id) => {
    const foundRepresentative = sourceData.find((r) => r._id === _id);
    return foundRepresentative;
  });
  return filledData;
};

const getProductsPerRepre = (assignmentData, sourceData) => {
  const filledData = [];
  for (const _idProduct in assignmentData) {
    if (Object.prototype.hasOwnProperty.call(assignmentData, _idProduct)) {
      const qty = assignmentData[_idProduct];
      const label = sourceData.find((p) => p._id === _idProduct).name;
      filledData.push({ qty, label, _id: _idProduct });
    }
  }
  return filledData;
};

function SelectProducts({ onSelect, products, loading }) {
  const [value, setValue] = useState("");
  const handleChange = (event) => {
    const value = event.target.value;
    if (value) {
      onSelect(value);
      setValue("");
    }
  };

  return (
    <FormControl variant="outlined" size="small" fullWidth>
      <InputLabel id="select-label">Seleccione una opción</InputLabel>
      <Select
        labelId="select-label"
        value={value}
        onChange={handleChange}
        label="Seleccione una opción"
        disabled={loading}
      >
        <MenuItem value="">
          <em>Seleccione una opción</em>
        </MenuItem>
        {products.map((p) => {
          const active =
            p.status === "661821d27b4df03548c403f8" || p.status === 1;
          return (
            <MenuItem
              key={p._id}
              value={p._id}
              disabled={!active}
            >
              {p.name}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}
